// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/client_events_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message protogen.RecordClientEventRequest
 */
export class RecordClientEventRequest extends Message<RecordClientEventRequest> {
  /**
   * @generated from field: string eventName = 1;
   */
  eventName = "";

  /**
   * @generated from field: map<string, string> meta = 2;
   */
  meta: { [key: string]: string } = {};

  constructor(data?: PartialMessage<RecordClientEventRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RecordClientEventRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "meta", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RecordClientEventRequest {
    return new RecordClientEventRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RecordClientEventRequest {
    return new RecordClientEventRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RecordClientEventRequest {
    return new RecordClientEventRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RecordClientEventRequest | PlainMessage<RecordClientEventRequest> | undefined, b: RecordClientEventRequest | PlainMessage<RecordClientEventRequest> | undefined): boolean {
    return proto3.util.equals(RecordClientEventRequest, a, b);
  }
}

/**
 * @generated from message protogen.RecordClientEventResponse
 */
export class RecordClientEventResponse extends Message<RecordClientEventResponse> {
  constructor(data?: PartialMessage<RecordClientEventResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RecordClientEventResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RecordClientEventResponse {
    return new RecordClientEventResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RecordClientEventResponse {
    return new RecordClientEventResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RecordClientEventResponse {
    return new RecordClientEventResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RecordClientEventResponse | PlainMessage<RecordClientEventResponse> | undefined, b: RecordClientEventResponse | PlainMessage<RecordClientEventResponse> | undefined): boolean {
    return proto3.util.equals(RecordClientEventResponse, a, b);
  }
}

